import RoleButtonLink from 'components/RoleButtonLink';
import React from 'react';
import { ADMIN } from 'components/RoleGate/constants';
import { IMPORT_PEOPLE_MODAL } from '../..';

export default function ImportPeopleLinkButton(): React.ReactElement {
    return (
        <RoleButtonLink
            buttonProps={{
                primary: true
            }}
            params={{
                [IMPORT_PEOPLE_MODAL]: true
            }}
            requiredRoles={[ADMIN]}
        >
            + Import people
        </RoleButtonLink>
    );
}
